import {AsyncInlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

import {FeatureNotEnabledError} from '../../shared/Errors/FeatureNotEnabledError.js'
import {SellerRepositoriesFactory} from '../Repositories/factory.js'
import {ContactConfiguratorNotLoggedSellerRequest} from '../Requests/ContactConfiguratorNotLoggedSellerRequest.js'

class ContactConfiguratorNotLoggedSellerUseCase extends UseCase {
  #repository
  #isFeatureEnabled

  constructor({repository, isFeatureEnabled}) {
    super()
    this.#repository = repository
    this.#isFeatureEnabled = isFeatureEnabled
  }

  static create({config, repository}) {
    const isMotos = config.get('APP_NAME') === config.get('APP_NAME_MOTOS')
    return new ContactConfiguratorNotLoggedSellerUseCase({
      repository: SellerRepositoriesFactory.hTTPSellerRepository({config}),
      isFeatureEnabled: !isMotos
    })
  }

  @tracer({metric: 'ContactConfiguratorNotLoggedSellerUseCase#execute'})
  @AsyncInlineError()
  async execute(params) {
    if (!this.#isFeatureEnabled) {
      return Promise.reject(FeatureNotEnabledError.create('Feature not enabled'))
    }
    const {dealerId, specsId, color, buyer} = params
    const contactConfiguratorNotLoggedSellerRequest = ContactConfiguratorNotLoggedSellerRequest.create({
      dealerId,
      specsId,
      color,
      buyer
    })
    const [error, response] = await this.#repository.contactConfiguratorNotLoggedSeller({
      contactConfiguratorNotLoggedSellerRequest
    })

    if (error) return Promise.reject(error)

    return response
  }
}

export const factory = ContactConfiguratorNotLoggedSellerUseCase.create
